// utils.js
export const hexToRgb = (hex) => {
  hex = hex.replace(/^#/, '');
  const bigint = parseInt(hex, 16);
  return {
    red: (bigint >> 16) & 255,
    green: (bigint >> 8) & 255,
    blue: bigint & 255,
  };
};

export const getRgbaColor = (color, brightness) => {
  const { red, green, blue } = hexToRgb(color);
  return `rgba(${red}, ${green}, ${blue}, ${brightness / 100})`;
};

export const getTextColor = (color, brightness) => {
  const { red, green, blue } = hexToRgb(color);
  const luminance =
    (0.299 * red + 0.587 * green + 0.114 * blue) * (brightness / 100);
  return luminance > 128 ? '#000' : '#fff';
};
